import { render, staticRenderFns } from "./THYFareFeatures.vue?vue&type=template&id=b6a48eb8&scoped=true"
import script from "./THYFareFeatures.vue?vue&type=script&lang=js"
export * from "./THYFareFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a48eb8",
  null
  
)

export default component.exports